import styled from 'styled-components';
import { TextArea as _TextArea } from 'components/Inputs';
import _LoadingOverlay from 'components/LoadingOverlay';

export const LoadingOverlay = styled(_LoadingOverlay)`
  position: fixed;
`;

export const InstructionList = styled.ol`
  font-size: 14px;
  margin-bottom: 32px;
  > li {
    margin-bottom: 8px;
  }
`;

export const TextArea = styled(_TextArea)`
  margin-top: 20px;
  > textarea {
    resize: vertical;
    min-height: 100px;
  }
`;

export const Buttons = styled.div`
  margin-top: 20px;
  > :first-child {
    margin-right: 16px;
  }
`;
